import React from 'react';
import { Compass } from 'lucide-react';
import { immersiveClipUrl } from '../../data/foundingProgram';
export function ImmersiveExperiencePillars() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#0B0A0E]" data-id="element-1418" data-mp="hvf8hlvrhvaq">
      <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8" data-id="element-1419" data-mp="lxtrc5zfkv20">
        <div className="grid gap-10 lg:grid-cols-[0.38fr_0.62fr] lg:items-end" data-id="element-1420" data-mp="qqd4j1u7ho6a">
          <div data-id="element-1421" data-mp="vpgacoi0fyfb">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1422" data-mp="vpzhrba1b4f3">
              The vision
            </p>
            <h2 className="mt-5 font-serif text-4xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1423" data-mp="10mpx1we0lvzg">
              An empire this rich deserves more than a paragraph.
            </h2>
            <p className="mt-6 max-w-md text-lg font-light leading-relaxed text-[#FDFBF7]/65" data-id="element-1424" data-mp="19nxvcegj6wtj">
              Step inside the Lahore Darbar through cinematic storytelling at
              Illuminarium in Toronto&rsquo;s Distillery District.
            </p>
            <p className="mt-7 flex items-center gap-2 text-[10px] uppercase tracking-[0.24em] text-[#D4AF37]" data-id="element-1425" data-mp="35iiyr6gfqds">
              <Compass className="h-4 w-4" aria-hidden="true" data-id="element-1426" data-mp="3ukg6yacoinke" />
              Enter the world, early immersive concept
            </p>
          </div>

          <video src={immersiveClipUrl} autoPlay loop muted playsInline controls className="aspect-video w-full border border-[#D4AF37]/25 bg-black object-cover" data-id="element-1427" data-mp="3plliars164sd" />
        </div>
      </div>
    </section>;
}